import '@/assets/stylesheets/styles.scss';
import { ErrorPage } from '@/components/shared';
import * as Sentry from '@sentry/react';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Router } from './routes';

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Sentry.ErrorBoundary fallback={<ErrorPage type='Error' />}>
        <Router />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  );
};
